/**
 * @generated SignedSource<<b10ea235372228454b4e9444bb4b65a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BookmarksRemoveMutation$variables = {
  id: string;
};
export type BookmarksRemoveMutation$data = {
  readonly removeBookmark: boolean;
};
export type BookmarksRemoveMutation = {
  response: BookmarksRemoveMutation$data;
  variables: BookmarksRemoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "removeBookmark",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookmarksRemoveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookmarksRemoveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5415b0ea5f9bf20739c6b2926fc7e64a",
    "id": null,
    "metadata": {},
    "name": "BookmarksRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation BookmarksRemoveMutation(\n  $id: ID!\n) {\n  removeBookmark(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "9eafe60eab74ae09133a4b71cb12326c";

export default node;
